import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { IsoDateTime } from "@figurepos/fgr-lib-business-logic/lib/common/dateTime/types"
import type { SendOperationFormData } from "./SendOperationForm"
import type { SendCommandFormData } from "./SendCommandForm"
import type { SendRawOperationsFormData } from "./SendRawOperationsForm"
import type { SetFeatureFlagFormData } from "./SetFeatureFlagForm"
import type { RemoteScreenshotFormData } from "./RemoteScreenshotForm"
import type { SendEventFormData } from "./SendEventForm"

export const SEND_OPERATION_FORM_SUBMITTED = "sendOperation/form/submitted"

export const sendOperationFormSubmitted = (values: SendOperationFormData) => ({
    type: SEND_OPERATION_FORM_SUBMITTED,
    payload: {
        values: values,
    },
})

export const SEND_EVENT_FORM_SUBMITTED = "sendEvent/form/submitted"

export const sendEventFormSubmitted = (values: SendEventFormData) => ({
    type: SEND_EVENT_FORM_SUBMITTED,
    payload: {
        values: values,
    },
})

export const SEND_COMMAND_FORM_SUBMITTED = "sendCommand/form/submitted"

export const sendCommandFormSubmitted = (values: SendCommandFormData) => ({
    type: SEND_COMMAND_FORM_SUBMITTED,
    payload: {
        values: values,
    },
})

export const SEND_RAW_OPERATIONS_FORM_SUBMITTED = "sendRawOperations/form/submitted"

export const sendRawOperationsFormSubmitted = (values: SendRawOperationsFormData) => ({
    type: SEND_RAW_OPERATIONS_FORM_SUBMITTED,
    payload: {
        values: values,
    },
})

export const SET_FEATURE_FLAG_FORM_SUBMITTED = "setFeatureFlag/form/submitted"

export const setFeatureFlagFormSubmitted = (values: SetFeatureFlagFormData) => ({
    type: SET_FEATURE_FLAG_FORM_SUBMITTED,
    payload: {
        values: values,
    },
})

export const ASSIGN_USER_FORM_SUBMITTED = "assignUser/form/submitted"

export const assignUserFormSubmitted = (email: string, assign: boolean, adminRoleId: Maybe<string>) => ({
    type: ASSIGN_USER_FORM_SUBMITTED,
    payload: {
        email: email,
        assign: assign,
        adminRoleId: adminRoleId,
    },
})

export const REMOTE_SCREENSHOT_FORM_SUBMITTED = "remoteScreenshot/form/submitted"

export const remoteScreenshotFormSubmitted = (values: RemoteScreenshotFormData) => ({
    type: REMOTE_SCREENSHOT_FORM_SUBMITTED,
    payload: {
        values: values,
    },
})

export const REMOTE_SCREENSHOT_START_POLLING = "remoteScreenshot/startPolling"

export const remoteScreenshotStartPolling = (imagePollingUrl: string) => ({
    type: REMOTE_SCREENSHOT_START_POLLING,
    payload: {
        imagePollingUrl: imagePollingUrl,
    },
})

export const REMOTE_SCREENSHOT_STOP_POLLING = "remoteScreenshot/stopPolling"

export const remoteScreenshotStopPolling = (imagePollingUrl: string) => ({
    type: REMOTE_SCREENSHOT_STOP_POLLING,
    payload: {
        imagePollingUrl: imagePollingUrl,
    },
})

export const REMOTE_SCREENSHOT_FORM_SUBMIT_SUCCESS = "remoteScreenshot/form/submitSuccess"

export const remoteScreenshotFormSubmitSuccess = (imageUrl: string) => ({
    type: REMOTE_SCREENSHOT_FORM_SUBMIT_SUCCESS,
    payload: {
        imageUrl: imageUrl,
    },
})

export const REMOTE_SCREENSHOT_FORM_SUBMIT_FAILURE = "remoteScreenshot/form/submitFailure"

export const remoteScreenshotFormSubmitFailure = (error: string) => ({
    type: REMOTE_SCREENSHOT_FORM_SUBMIT_FAILURE,
    payload: {
        error: error,
    },
})

export const REMOTE_SCREENSHOT_LOADING_SUCCESS = "remoteScreenshot/loading/success"

export const createActionRemoteScreenshotLoadingSuccess = (imageUrl: Maybe<string>) => ({
    type: REMOTE_SCREENSHOT_LOADING_SUCCESS,
    payload: {
        imageUrl: imageUrl,
    },
})

export const CONSOLE_DATA_READY = "console/dataReady"

export const consoleDataReady = (data: any[], timestamp: IsoDateTime) => ({
    type: CONSOLE_DATA_READY,
    payload: {
        timestamp: timestamp,
        data: data,
    },
})

export const CLEAR_CONSOLE_DATA = "CLEAR_CONSOLE_DATA"

export const createActionClearConsoleData = () => ({
    type: CLEAR_CONSOLE_DATA,
})

export const COPY_PRODUCT_MENU_REQUESTED = "copyProductMenu/requested"

export const createActionCopyProductMenuRequested = (sourceAccountId: string) => ({
    type: COPY_PRODUCT_MENU_REQUESTED,
    payload: {
        sourceAccountId: sourceAccountId,
    },
})

export const SEND_EVENT_SUCCESS = "event/send/success"

export const sendEventSuccess = () => ({
    type: SEND_EVENT_SUCCESS,
    payload: {},
})

export const SEND_EVENT_FAILURE = "event/send/failure"

export const sendEventFailure = (error: any) => ({
    type: SEND_EVENT_FAILURE,
    payload: {
        error: error,
    },
})

export const SET_ONDY_PLATFORM = "SET_ONDY_PLATFORM"
export const createActionSetOndyPlatform = (platform: string) => ({
    type: SET_ONDY_PLATFORM,
    payload: { platform: platform },
})

export const ONDY_PLATFORM_CHANGED = "ONDY_PLATFORM_CHANGED"
export const createActionOndyPlatformChanged = (platform: string) => ({
    type: ONDY_PLATFORM_CHANGED,
    payload: { platform: platform },
})
